import axios from "axios";
import store from "../store";

/**
 * Unlike the other src/api modules, baseURL is resolved per call rather than at module
 * scope. store.js registers the liveOrders Vuex module, which imports this file, so at
 * import time store.js has not finished evaluating and `store` is still undefined.
 * Reading the getter lazily sidesteps the cycle.
 */
const baseURL = () => store.getters.mainAppURL + "orders/";

const getLiveOrders = (params) => axios.get(baseURL() + "live_orders", {params});
const getLiveOrderCounts = () => axios.get(baseURL() + "live_orders/counts");

export {
    getLiveOrders,
    getLiveOrderCounts
}
